export const getUnitLabel = (dueUnit, intl) => {
    let options = [
    	intl.formatMessage({ id: 'app.chart.day' }),
    	intl.formatMessage({ id: 'app.chart.week' }),
    	intl.formatMessage({ id: 'app.chart.month' })
    ];

    return options[dueUnit]
}

export const getTreatmentLabel = (treatmentPhaseId, intl) => {
    let treatmentPhase = [
    	intl.formatMessage({ id: 'app.chart.pre' }),
    	intl.formatMessage({ id: 'app.chart.treatment' }),
    	intl.formatMessage({ id: 'app.chart.post' })
    ]
    
    return treatmentPhase[treatmentPhaseId]
}

export const getTopTreatmentLabel = (treatmentPhaseId, intl) => {
    let treatmentPhase = [
    	intl.formatMessage({ id: 'app.chart.preTopLabel' }),
    	intl.formatMessage({ id: 'app.chart.treatmentTopLabel' })
    ]
    
    return treatmentPhase[treatmentPhaseId]
}

export const spreadValues = (min, max, cardinality) => {
    var arr = []
    var step = (max - min) / (cardinality - 1)
    for (var i = 0; i < cardinality; i++) {
        arr.push(min + (step * i))
    }

    return arr
}

export const renderTopLabel = (id, data, min, max, intl) => {
    let result = data.find(({ xAxis }) => xAxis == id)
    let dateLabel = ''
    let isLastCompleted = result.completed && !data.find(({ xAxis, completed }) => xAxis > result.xAxis && completed)
    if(isLastCompleted || result.upcoming || (result.isDue && !result.completed)) {
        let date = intl.formatDate(result.completed ? result.completionDate : result.dueDate, { year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC' })
        dateLabel = '<span class="dateLabel">' + date + '</span>'
    }

    let header = getPointHeader(result, data, isLastCompleted, intl)

    return `<span class="xTopLabel ${!result.isDue && !result.completed && !result.upcoming ? 'xTopLabelFuture' : ''}"><span class="xTopLabelText" 
        style="cursor: ${(result.isDue && !result.completed) ? 'pointer' : 'default'}; color: ${result.completed ? (result.isRead ? '#000000' : '#5EA510') : result.isDue ? '#F54336' : '#777a7e'};">
            <span style="font-weight: ${result.completed ? (result.isRead ? 'normal' : 'normal') : result.isDue ? 'normal' : 'bold'};">
                ${header}
            </span>
            ${dateLabel}
        </span></span>`
}

export const getScoreLabel = (score) => {
    let scoreLabel = `${+parseFloat((score).toFixed(1))}`
    return scoreLabel
}

export const getDueLabel = (point, intl) => {
    let label = point.labelTreatmentPhaseId == 2 ? point.labelValue + getUnitLabel(point.labelUnit, intl) : getTopTreatmentLabel(point.labelTreatmentPhaseId, intl)

    return `<span class="boxDueLabel"><span class="material-icons">calendar_today</span><span class="boxDueLabelDate">${label}</span></span>`
}

export const getPointHeader = (point, data, isLastCompleted, intl) => {
    let header = ''
    let additionalClass = "";
    if (point.completed) {
        if (!point.isRead && isLastCompleted) {
            header = `${intl.formatMessage({ id: 'app.chart.newScore' })}`
        } else {
            //header = data.find(({ xAxis, completed }) => xAxis > point.xAxis && completed) ? '' : intl.formatMessage({ id: 'app.chart.completed' })
        }
    } else {
        if (point.isDue) {
            header = intl.formatMessage({ id: "app.chart.due" });
          } else if (point.upcoming) {
            header = intl.formatMessage({ id: "app.chart.upcoming" });
            additionalClass = "labelHeaderUpcoming";
          }
    }

    const finalClass = `labelHeader ${additionalClass}`.trim();
  
    return `<span class="${finalClass}">${header}</span>`;
}
